"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Command = exports.RadioSurveyCommand = exports.UpdateOtaCommand = exports.FactoryResetCommand = exports.RebootCommand = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const json_1 = require("../../../json");
const semver_1 = require("../../../semver");
exports.NAMESPACE = 'Culligan.Protocol.Common.System';
exports.RebootCommand = effect_1.Schema.Struct({ command: effect_1.Schema.tag('reboot') }).annotations({
    identifier: `${exports.NAMESPACE}.RebootCommand`,
    title: 'Reboot',
    description: 'Instruct the device to reboot',
});
exports.FactoryResetCommand = effect_1.Schema.Struct({ command: effect_1.Schema.tag('factory.reset') }).annotations({
    identifier: `${exports.NAMESPACE}.FactoryResetCommand`,
    title: 'Factory Reset',
    description: 'Instruct the device to reset to factory defaults',
});
exports.UpdateOtaCommand = effect_1.Schema.Struct({
    command: effect_1.Schema.tag('ota.update'),
    params: effect_1.Schema.Struct({
        url: effect_1.Schema.NonEmptyTrimmedString,
        buildFile: effect_1.Schema.NonEmptyTrimmedString,
        targetVersion: semver_1.SemVer,
        options: json_1.Value,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.UpdateOtaCommand`,
    title: 'Update OTA',
    description: 'Instruct the device to update to a new version of its firmware via OTA',
});
exports.RadioSurveyCommand = effect_1.Schema.Struct({
    command: effect_1.Schema.tag('radio.survey'),
}).annotations({
    identifier: `${exports.NAMESPACE}.RadioSurveyCommand`,
    title: 'Radio Survey',
    description: 'Instruct the device to perform a radio survey',
});
exports.Command = effect_1.Schema.Union(exports.RebootCommand, exports.FactoryResetCommand, exports.UpdateOtaCommand, exports.RadioSurveyCommand).annotations({
    identifier: `${exports.NAMESPACE}.Command`,
    title: 'Command',
    description: 'A command to be sent to the device',
});
//# sourceMappingURL=system.js.map